<template>
    <section>
        <div class="page-wrap">
            <div class="container">
                <div class="box-content">
                    <img class="info-icon pointer pull-right"
                         src="images/information.png"
                         v-on:click="showInformation()"
                         alt=""
                    />
                    <h2>Customize Your Order</h2>
                    <div>
                        <p class="shop-page-text">
                            Select an option below to customize your personalized message. For orders outside the contiguous United States (International, Alaska or Hawaii) please call 1-888-223-0291, and a customer service specialist will be happy to assist you. All materials subject to change based on final architectural design.
                        </p>
                    </div>
                    <catalog></catalog>
                </div>
            </div>
        </div>
    </section>
</template> 
 
<script type="text/jsx">
    import { Event } from '../../../../assets/js/components/frontend/event.vue'
    import Catalog from './shop/Catalog.vue';
    export default {
        name: 'shop',
        props: {
        },
        mixins: [
        ],
        data: function () {
            return this.getDefaultData();
        },
        components: {
            'catalog': Catalog
        },
        created: function () {
        },
        methods: {
            getDefaultData: function () {
                return {
                }
            },
            showInformation: function () {
                Event.$emit(
                    'brickPackagesPopup'
                );
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Shop.vue?67d130e0